import * as React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { eventBus } from './EventBus';
import { startEventsSync } from './crossTab';
import { originId } from './originId';
import { applyEvent } from './applyEvent';
import { eventHandlerRegistry } from './eventHandlerRegistry';
import type { SystemEventResponse } from '../../types/event.types';

type EventsProviderProps = {
    children: React.ReactNode;
};

const EventsProvider = ({ children }: EventsProviderProps) => {
    const queryClient = useQueryClient();

    React.useEffect(() => startEventsSync(), []);

    React.useEffect(() => eventBus.subscribe((event: SystemEventResponse) =>
        applyEvent(event, queryClient, originId, eventHandlerRegistry)
    ), [queryClient]);

    return <>{children}</>;
};

export default EventsProvider;
